import styled from 'styled-components'

import plusIcon from 'static/img/dark_plus.svg'
import minusIcon from 'static/img/minus_dark.svg'

export const Legend = styled.legend`
  font-size: 22px;
  margin-bottom: 13px;
`

export const LegendAccordion = styled(Legend)`
  position: relative;
  padding-right: 30px;
  width: 100%;
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
    height: 15px;
    background-image: url(${({ isOpen }) => (isOpen ? minusIcon : plusIcon)});
    background-size: contain;
    background-repeat: no-repeat;
  }
`

export const Fieldset = styled.fieldset`
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral};
  padding-bottom: 10px;
`

export const Label = styled.label`
  margin-top: 8px;
  font-size: 16px;
  font-weight: normal;
  display: block;
`
